import { Features } from 'generated/featureDefinitions'

import type { FeatureAvailabilityType } from 'modules/core/hooks/useFeatureAvailability'

export const isFeatureAvailabilityEnabled = (
  featureAvailabilities: FeatureAvailabilityType[],
  feature: Features
) => {
  return (
    featureAvailabilities.find((featureAvailability) => featureAvailability.id === feature)
      ?.available ?? false
  )
}
